export function makeUrl(rootRelativeUri: string) {
	if (!rootRelativeUri) return rootRelativeUri;
	let r = new RegExp('^(?:[a-z]+:)?//', 'i');
	if (r.test(rootRelativeUri)) return rootRelativeUri;

	let baseUrl = (window as any).CareEv?.BaseUrl;
	if (!baseUrl) { return rootRelativeUri; }

	if (baseUrl && baseUrl.length > 0 && baseUrl.charAt(baseUrl.length - 1) !== '/') baseUrl += '/';

	if (rootRelativeUri.length >= baseUrl.length &&
		rootRelativeUri.substring(0, baseUrl.length) === baseUrl) return rootRelativeUri;

	if (rootRelativeUri.charAt(0) === '/') rootRelativeUri = rootRelativeUri.substring(1);

	return baseUrl + rootRelativeUri;
}